import { Upload as AntUpload } from 'antd';
import css from './upload.module.scss';

const preProps = {
    name: 'file',
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    headers: {
        authorization: 'authorization-text',
    },
};
const Upload = ({ children, ...rest }: any) => {
    const classList = [css.efUpload];
    const props = { ...rest, ...preProps };
    if (rest.className) {
        classList.push(rest.className);
        props.className = classList.join(' ');
    }
    return <AntUpload {...props} />;
};

export default Upload;
